export const ATTRIBUTE_SOURCES = ['editor', 'google', 'osm', 'scraper', 'category-default'];
/** Higher wins. google and osm share a rank (newer wins between them). */
export const ATTRIBUTE_SOURCE_RANK = {
    editor: 4,
    google: 3,
    osm: 3,
    scraper: 2,
    'category-default': 1,
};
export const PRICE_LEVELS = [0, 1, 2, 3, 4];
export const WALKING_EFFORTS = ['low', 'moderate', 'high'];
export const INDOOR_OUTDOOR = ['indoor', 'outdoor', 'mixed'];
export const BOOKING_POLICIES = ['none', 'recommended', 'required'];
export const TERRAINS = ['paved', 'gravel', 'trail'];
export const DIETARY_OPTIONS = ['vegan', 'vegetarian', 'gluten_free', 'lactose_free', 'halal', 'kosher'];
export const MEALS = ['breakfast', 'brunch', 'lunch', 'dinner', 'late'];
export const HHMM_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
export const ATTRIBUTE_SLUG_PATTERN = /^[a-z0-9][a-z0-9_-]{0,39}$/;
/** Every leaf path an attribute slot can live at. */
export const ATTRIBUTE_PATHS = [
    // cross-type (17)
    'price.level',
    'price.from',
    'openingPeriods',
    'age.min',
    'age.max',
    'accessibility.stepFree',
    'accessibility.wheelchair',
    'accessibility.accessibleToilet',
    'accessibility.seating',
    'accessibility.lift',
    'accessibility.walkingEffort',
    'indoorOutdoor',
    'typicalDurationMin',
    'booking',
    'petsAllowed',
    'contact.website',
    'contact.phone',
    // per content type (11)
    'dining.cuisine',
    'dining.dietary',
    'dining.meals',
    'arts.guidedTours',
    'arts.audioGuide',
    'nature.terrain',
    'shopping.productCategories',
    'events.start',
    'events.end',
    'events.recurrence',
    'events.ticketRequired',
];
/** Boolean leaves: stored true/false only; unknown is absence. */
export const TRI_STATE_PATHS = [
    'accessibility.stepFree',
    'accessibility.wheelchair',
    'accessibility.accessibleToilet',
    'accessibility.seating',
    'accessibility.lift',
    'petsAllowed',
    'arts.guidedTours',
    'arts.audioGuide',
    'events.ticketRequired',
];
/** The cross-type leaves the admin editor shows. */
export const EDITOR_CROSS_TYPE_PATHS = ATTRIBUTE_PATHS.slice(0, 17);
/** Which taxonomy groups each per-type section applies to (data only, for later tickets). */
export const ATTRIBUTE_SECTION_GROUPS = {
    dining: ['dining-nightlife'],
    arts: ['arts-culture', 'entertainment-leisure'],
    nature: ['nature-outdoors'],
    shopping: ['shopping-markets'],
    events: ['events-festivals'],
};
//# sourceMappingURL=markerAttributes.js.map